import React from 'react';
import { UserMessage, Error } from 'Assistant/Chatbot';
import { useConversationStarters } from 'Assistant/Chatbot/hooks';
import { v4 as uuidv4 } from 'uuid';
import LoadingIndicator from 'Shared/LoadingIndicator';
import { useTranslation } from 'react-i18next';
import { tracking } from 'App/Tracking';
import * as S from './styles';

type ChatbotStartersProps = {
  handleSubmitRedirect(message: UserMessage): Promise<void>;
};

const ChatbotStarters = ({ handleSubmitRedirect }: ChatbotStartersProps) => {
  const {
    conversationStarters,
    isLoadingConversationStarters,
    errorFetchingConversationStarters,
    refetchConversationStarters,
  } = useConversationStarters();
  const { t: translate } = useTranslation('chatbot');

  if (errorFetchingConversationStarters) {
    return (
      <Error
        title={translate('chatbot_starters.fetch_conversation_starters_error')}
        orientation="vertical"
        onTryAgainPress={async () => {
          await refetchConversationStarters();
        }}
      />
    );
  }

  return (
    <S.ConversationStartersContainer>
      {isLoadingConversationStarters ? (
        <LoadingIndicator />
      ) : (
        conversationStarters.map(starter => (
          <S.ConversationStarter
            key={starter.id}
            aria-label={`Start a conversation: ${starter.text}`}
            onClick={async () => {
              tracking.track('ai-coach-chatbot-starter-suggestion-clicked', {
                source: 'homepage-chatbot-ui',
                message: `${starter.emoji} ${starter.text}`,
                topic: starter.topic,
                starterId: starter.id,
              });

              void handleSubmitRedirect({
                id: uuidv4(),
                createdAt: new Date().toISOString(),
                content: starter.text,
                topic: starter.topic,
                starterId: starter.id,
              });
            }}
          >
            <S.ConversationStarterEmoji aria-hidden={true}>
              {starter.emoji}
            </S.ConversationStarterEmoji>
            <S.ConversationStarterText>
              {starter.text}
            </S.ConversationStarterText>
          </S.ConversationStarter>
        ))
      )}
    </S.ConversationStartersContainer>
  );
};

export { ChatbotStarters };
